import Header from '../components/Home/Header';
import Def from '../components/Home/Def';
import Tests from '../components/Home/Tests';
import Why from '../components/Home/Why';
import Gr8 from '../components/Home/Gr8';
import Testimonials from '../components/Home/Testimonials';

const Home = () => {
  return (
    <div className="home">
      <Header/>
      <Def/>
      <Tests/>
      <Why/>
      <Gr8/>
      <Testimonials/>
    </div>
  );
};

export default Home;